module.exports = {
  'a': true,
  'abbr': true,
  'b': true,
  'bdi': true,
  'bdo': true,
  'br': true,
  'cite': true,
  'code': true,
  'data': true,
  'dfn': true,
  'em': true,
  'i': true,
  'kbd': true,
  'mark': true,
  'q': true,
  'rp': true,
  'rt': true,
  'ruby': true,
  's': true,
  'samp': true,
  'small': true,
  'span': true,
  'strong': true,
  'sub': true,
  'sup': true,
  'time': true,
  'u': true,
  'var': true,
  'wbr': true,
  'audio': true,
  'img': true,
  'video': true,
  'del': true,
  'ins': true
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/attributed-string-bml-tags.js
 ** module id = 19
 ** module chunks = 0
 **/